import { Weld, ClaimWeldInput, CrewMember, ReclaimWeldInput, WeldProcedure, GeoLocation } from '@bechtel/types';

export interface ClaimReclaimWeldProps {
  weldCommodity: Weld;
  close: () => void;
  isReclaim?: boolean;
  isClaimAndApprove?: boolean;
  refetchQueries?: string[];
}

export interface FormikState {
  showMap: boolean;
  weldProcedures: WeldProcedure[] | null;
  stencils: CrewMember[];
  locationDesc: ClaimWeldInput['locationDescription'];
  mediaMetadata: ClaimWeldInput['attachmentMetadata'];
  weldedLocation: GeoLocation | null;
  comments: ReclaimWeldInput['comments'];
}
